import React from 'react';
import Main from './components/Main';
import './index.scss';

const SuperMarketPage = () => {
    return (
        <div>
            <Main />
        </div>
    )
}
export default SuperMarketPage
